import { BaseApiHandler } from "@/services/apiHandlers/baseApiHandler";
import type {
  ICategories,
  ICategoriesApiResponse,
  ICategoriesMetaDetailsRequest,
  ICategoryMetaDataApiResponse,
} from "@/services/apiHandlers/categories/types";
import { BackendResponseModelTypes } from "@/services/http/types";

class CategoriesApiHandler extends BaseApiHandler {
  constructor() {
    super();
  }

  public async getCategories(): Promise<ICategories[]> {
    const categoriesResponse = await this.request.applicationsFetcher.get<
      ICategoriesApiResponse[]
    >({
      url: "application-categories",
      cache: "force-cache",
      responseModel: BackendResponseModelTypes.WithData,
    });

    return categoriesResponse
      .sort((a, b) => a.position - b.position)
      .map(({ id, name, alias, description }) => ({
        id,
        value: alias,
        label: name,
        description,
      }));
  }

  public async getCategoryMetaDetails({
    categoryAlias,
  }: ICategoriesMetaDetailsRequest) {
    return this.request.applicationsFetcher.get<ICategoryMetaDataApiResponse>({
      url: `application-categories/by-alias/${categoryAlias}/meta-details`,

      responseModel: BackendResponseModelTypes.WithData,
      next: { revalidate: 300 },
    });
  }
}

const categoriesApiHandler = new CategoriesApiHandler();

export default categoriesApiHandler;
